import { render, staticRenderFns } from "./DamageCard.vue?vue&type=template&id=31c79fa6"
import script from "./DamageCard.vue?vue&type=script&lang=ts"
export * from "./DamageCard.vue?vue&type=script&lang=ts"
import style0 from "./DamageCard.vue?vue&type=style&index=0&id=31c79fa6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports